/**
 * The Floor Plan step's plan marks from its two lighters (`floor-plan-page-identify`, R12–R13;
 * `onboarding-status-colours-plan-machines`, R5): the title-bar search's matches, drawn as selected,
 * and the identify card's open group, being edited, told apart so each is drawn for what it is; and
 * the machines an identify has just written, which take the arrival glow once (`usePlanEntitySettle`
 * glows an id once per entry).
 *
 * The search's own set is passed through as it is. Undefined when there is nothing to show, so the
 * planner draws its own check marks unchanged.
 */
export interface IdentifyEntityMarks {
  searchMatched?: ReadonlySet<string>;
  identifying?: ReadonlySet<string>;
  arrived?: ReadonlySet<string>;
}

export const identifyEntityMarks = ({
  searchLit,
  groupLit,
  arrived,
}: {
  searchLit: ReadonlySet<string> | null | undefined;
  groupLit: readonly string[] | null | undefined;
  arrived: ReadonlySet<string> | null | undefined;
}): IdentifyEntityMarks | undefined => {
  const searchMatched = searchLit && searchLit.size > 0 ? searchLit : undefined;
  const identifying = groupLit && groupLit.length > 0 ? new Set<string>(groupLit) : undefined;
  const glow = arrived && arrived.size > 0 ? arrived : undefined;
  if (!searchMatched && !identifying && !glow) return undefined;
  return {
    ...(searchMatched ? { searchMatched } : {}),
    ...(identifying ? { identifying } : {}),
    ...(glow ? { arrived: glow } : {}),
  };
};
